
export function simulatorModalShown (workspace, modalName) {
  window.analytics.track('Modal Shown', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    modal_name: modalName
  })
}

export function simulatorModalClosed (workspace, didAcknowledge, modalName) {
  window.analytics.track('Modal Dismissed', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    modal_name: modalName,
    disable_show_again: didAcknowledge
  })
}

export function simulatorSendEventClicked (workspace, apiMethod, sourceMetadataSlug, integrationMetadataSlug) {
  window.analytics.track('Simulator Send Event Clicked', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    api_method: apiMethod,
    source_metadata_slug: sourceMetadataSlug,
    integration_metadata_slug: integrationMetadataSlug
  })
}

export function simulatorEventResponse (workspace, result, apiMethod, sourceMetadataSlug, integrationMetadataSlug) {
  window.analytics.track('Simulator Event Response', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    result,
    api_method: apiMethod,
    source_metadata_slug: sourceMetadataSlug,
    integration_metadata_slug: integrationMetadataSlug
  })
}
export function simulatorTabClicked (workspace, activeTab) {
  window.analytics.track('Tab Clicked', {
    workspace_slug: workspace.slug,
    workspace_id: workspace.id,
    location: 'simulator',
    tab: activeTab
  })
}



// WEBPACK FOOTER //
// ./analytics/simulator.js